<div class="app-login">
    <div class="body-app mt-3 mb-3">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <div class="content-app">
                <div class="row">
                    <div class="col-12">
                        <br /><br />
                        <div class="card card-search">
                            <div class="card-body">
                                <div class="text-center">
                                    <a routerLink="/" title="Nombre de la plataforma" class="mt-0 mb-3">
                                        <img src="assets/Images/logo.png" alt="Nombre de la plataforma" class="img-fluid mx-2" />
                                    </a>
                                </div>
                                <h5 class="mt-3 mb-3 text-center text-primary">
                                    Restablecer contraseña
                                </h5>
                                <form [formGroup]="form">
                                    <div class="form-group mb-3">
                                        <label>Nueva Contraseña</label>
                                        <div class="input-group">
                                            <input formControlName="newPassword" [attr.type]="showPassword() ? 'text' : 'password'"
                                                class="form-control" placeholder="Ingrese su nueva contraseña" />
                                            <button (click)="showPassword.set(!showPassword())" type="button"
                                                class="btn btn-primary">
                                                @if (showPassword()) {
                                                <i class="fa-solid fa-eye-slash"></i>
                                                }@else {
                                                <i class="fa-solid fa-eye"></i>
                                                }
                                            </button>
                                        </div>
                                        @if (form.get('newPassword')?.invalid && (form.get('newPassword')?.touched ||
                                        form.get('newPassword')?.dirty)) {
                                        @if (form.get('newPassword')?.errors?.['required']) {
                                        <div class="text-danger"
                                            *ngIf="form.get('newPassword')?.errors?.['required'] == true && form.get('newPassword')?.touched">
                                            La contraseña es requerida
                                        </div>
                                        }@else {
                                        <div class="text-danger" *ngIf="form.get('newPassword')?.hasError('minlength')">
                                            La contraseña debe tener al menos 6 caracteres.
                                        </div>
                                        <div class="text-danger" *ngIf="form.get('newPassword')?.hasError('requireUppercase')">
                                            {{ form.get('newPassword')?.errors?.['requireUppercase'].message }}
                                        </div>
                                        <div class="text-danger" *ngIf="form.get('newPassword')?.hasError('requireLowercase')">
                                            {{ form.get('newPassword')?.errors?.['requireLowercase'].message }}
                                        </div>
                                        <div class="text-danger" *ngIf="form.get('newPassword')?.hasError('requireDigit')">
                                            {{ form.get('newPassword')?.errors?.['requireDigit'].message }}
                                        </div>
                                        }
                                        }
                                    </div>
                                    <div class="form-group mb-3">
                                        <label>Confirmar Nueva Contraseña</label>
                                        <input formControlName="confirmPassword" type="password" class="form-control"
                                            placeholder="Confirme su nueva contraseña"/>
                                        <div class="text-danger"
                                            *ngIf="form.get('confirmPassword')?.errors?.['required'] == true && form.get('confirmPassword')?.touched">
                                            La confirmación de contraseña es requerida
                                        </div>
                                        <div class="text-danger" *ngIf="form.get('confirmPassword')?.errors?.['match']?.message">
                                            {{form.get('confirmPassword')?.errors?.['match']?.message}}
                                        </div>
                                    </div>
                                </form>
                                <div class="mt-3 mb-3">
                                    <button (click)="submit()" type="button" class="btn btn-primary w-100" [disabled]="isLoading()">
                                        <ng-container *ngIf="!isLoading()">
                                            <i class="fa-solid fa-key"></i>
                                        </ng-container>
                                        <ng-container *ngIf="isLoading()">
                                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </ng-container>
                                        Cambiar Contraseña
                                    </button>
                                </div>
                                <div class="text-center">
                                    <a [routerLink]="['/login']" class="text-decoration-none">
                                        <i class="fa-solid fa-circle-user"></i>
                                        Iniciar Sesión
                                    </a>
                                </div>
                            </div>
                        </div>
                        <br /><br />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
